var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRemoveRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 120,
    viewBox: "0 0 94 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 106.667C7.00016 114 13.0002 120 20.3335 120H73.6668C81.0002 120 87.0002 114 87.0002 106.667V40C87.0002 32.6667 81.0002 26.6667 73.6668 26.6667H20.3335C13.0002 26.6667 7.00016 32.6667 7.00016 40V106.667ZM27.0002 40H67.0002C70.6668 40 73.6668 43 73.6668 46.6667V100C73.6668 103.667 70.6668 106.667 67.0002 106.667H27.0002C23.3335 106.667 20.3335 103.667 20.3335 100V46.6667C20.3335 43 23.3335 40 27.0002 40ZM70.3335 6.66667L65.6002 1.93333C64.4002 0.733333 62.6668 0 60.9335 0H33.0668C31.3335 0 29.6002 0.733333 28.4002 1.93333L23.6668 6.66667H7.00016C3.3335 6.66667 0.333496 9.66667 0.333496 13.3333C0.333496 17 3.3335 20 7.00016 20H87.0002C90.6668 20 93.6668 17 93.6668 13.3333C93.6668 9.66667 90.6668 6.66667 87.0002 6.66667H70.3335Z",
    fill: "#F43E3E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemoveRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RemoveRed.b258b90d.svg";
export { ForwardRef as ReactComponent };